<h1>
  {{ api_service.page.title }}
</h1>
<div [innerHTML]="api_service.page.content.html"></div>
